import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Realestatesolutions() {
  return (
    <div
      className="Robustand realestate-solutions p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Advanced <span>Tech Solutions for Real Estate App</span>{" "}
              Development
            </h2>
            <p>
              We use a variety of cutting-edge technology to build long-lasting
              and highly efficient real estate apps. We simplify complex systems
              to enhance user experience, reduce friction, and address real
              estate-specific challenges.
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>AI and Machine Learning Integration</h4>
                  <p>
                    As a leading real estate app mobile development company, we
                    use artificial intelligence (AI) and machine learning to
                    analyze massive data sets and forecast pricing, prices for
                    real estate, and trends in the market.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Blockchain for Secure Real Estate Transactions</h4>
                  <p>
                    Our blockchain-based real estate apps ensure secure,
                    tamper-proof transactions, reducing fraud and streamlining
                    ownership transfers.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>AR/VR Integration</h4>
                  <p>
                    Our real estate software uses augmented reality to showcase
                    design potential and virtual reality for immersive property
                    tours, enhancing the user experience.
                  </p>
                </div>

                <div className="robust-content">
                  <h4>Metaverse Integration</h4>
                  <p>
                    Integrating the metaverse into your real estate apps enables
                    virtual open houses, life-like agent interactions, and full
                    property tours for a next-level experience.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>IoT and Data-Driven Insights</h4>
                  <p>
                    We leverage IoT and big data to provide buyers with key
                    property insights, offering a smarter, streamlined real
                    estate experience for both managers and buyers.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Realestatesolutions;
